import { Routes, Route} from 'react-router-dom';
import React from 'react'
import './App.css';

//import ProtectedRoute from './Components/ProtectedRoute';
import Home from './Components/home';
import ApplyNow from './Components/applyform';
import Services from './Components/services';
import CountrieCanada from './Components/countriecananda';
import CountrieUk from './Components/countrieuk';
import CountrieFrance from './Components/countriesfrance';
import CountrieAus from './Components/countriesaus';
import CountrieNez from './Components/countrienz';
import CountrieGer from './Components/countriegermany';
import About from './Components/about';
import ContactUS from './Components/contactus';
import CountrieUsa from './Components/countriesusa';
import NewLogin from './Components/newlogin';
import Dashboard from './Components/dashboard';

const App = () => (
  <Routes>
    <Route exact path="/" element={<Home />} />
    <Route exact path="/applyNow" element={<ApplyNow />} />
    <Route exact path='/services' element={<Services />} />
    <Route exact path='/countries/canada' element={<CountrieCanada />} />
    <Route exact path='/countries/united-kingdom' element={<CountrieUk />} />
    <Route exact path='/countries/france' element={<CountrieFrance />} />
    <Route exact path='/countries/australia' element={<CountrieAus />} />
    <Route exact path='/countries/new-zealand' element={<CountrieNez />} />
    <Route exact path='/countries/germany' element={<CountrieGer />} />
    <Route exact path='/countries/united-states' element={<CountrieUsa />} />
    <Route exact path='/about' element={<About />} />
    <Route exact path='/contact' element={<ContactUS />} />
    <Route exact path='/login' element={<NewLogin />} />
    <Route exact path='/dashboard' element={<Dashboard />} />
  </Routes>
)

export default App;
